module.exports = __webpack_public_path__ + "static/media/1001136MF.57d38dc9.jpg";